var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStats = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 6.75,
    width: 8.5,
    height: 4.5,
    rx: 1.25,
    transform: "rotate(90 5.25 6.75)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 3.75,
    width: 11.5,
    height: 4.5,
    rx: 1.25,
    transform: "rotate(90 12.25 3.75)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 0.75,
    width: 14.5,
    height: 4.5,
    rx: 1.25,
    transform: "rotate(90 19.25 0.75)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStats, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stats.3258f4f1.svg";
export { ForwardRef as ReactComponent };